import script from "./SellerDashboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerDashboardPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerDashboardPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__